import {AwesomeRoundCheckbox} from './awesome-round-checkbox';

export function BlackTopCard({header, checked, children}) {
  return (
    <div className='mb-4'>
      <div className='p-0 border'>
        <div className='bg-black text-white bg-black-900 px-2 py-2'>
          <div className={'flex gap-2 items-center'}>
            <AwesomeRoundCheckbox checked={checked} />
            <div>{header}</div>
          </div>
        </div>

        <div className='px-4 pt-2 pb-4'>{children}</div>
      </div>
    </div>
  );
}
